<template>
  <div class="ferramentas" v-if="possuiFerramentas">
    <div class="tit-ferramentas text-center">
      <div class="d-flex align-items-center justify-content-center">
        <img :src="iconeFerramentasEstudo"/>
        <h3>Ferramentas de Estudo da Lição</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12 simulados">
        <div class="box-branco">
          <b-tabs pills nav-class="abas-simulado d-flex align-items-center justify-content-center mb-4">
              <simulados :simulados="simulados" :quiz="quiz" :curso="curso" />
            <b-tab title-item-class="ml-2" class="col-12 mt-4" v-if="decks.length && $empresaUtils.temAcesso($tipoAcesso.SALA_DE_AULA_FLASHCARDS.nome, $configEmpresa.rotasRestritasAcesso)">
              <template slot="title">
                <img :src="iconFlashcard"  class="icon-sim" />
                  Flashcards
              </template>
              <flashcards :decks="decks" :curso="curso" />
            </b-tab>
          </b-tabs>
        </div>
      </div>

      <div class="col-12 mt-4" v-if="itensMemorize.length" v-show="false">
        <memorize :cartoesMemoria="itensMemorize" />
      </div>

    </div>
  </div>
</template>

<script>
import Memorize from '@/modules/SalaAula/components/ferramenta-estudo/items/Memorize'
import Simulados from '@/modules/SalaAula/components/ferramenta-estudo/items/Simulados'
import Flashcards from '@/modules/SalaAula/components/ferramenta-estudo/items/Flashcards'

export default {
  name: 'FerramentaEstudo',
  components: { Memorize, Simulados, Flashcards },
  props: {
    itensMemorize: Array,
    simulados: Array,
    quiz: {
      type: [Object, Array]
    },
    curso: Object,
    decks: Array
  },
  data () {
    return {
      licao: {
        nome: 'Lição 1.1'
      },
      iconeFerramentasEstudo: null
    }
  },
  created () {
    if (this.$configEmpresa.ferramentasEstudo && this.$configEmpresa.ferramentasEstudo.icone) {
      this.iconeFerramentasEstudo = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/${this.$configEmpresa.ferramentasEstudo.icone}`
    } else {
      this.iconeFerramentasEstudo = require('@/assets/img/livro-jaleko-verde.svg')
    }
  },
  computed: {
    possuiFerramentas: function () {
      return this.itensMemorize.length || (this.quiz && (this.quiz.questoes && this.quiz.questoes.length)) || this.simulados.length || this.decks.length
    },
    iconFlashcard: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/flip-flashcards.svg`
    },
    configEmpresa: function () {
      return this.$store.getters.empresa
    }
  }
}
</script>

<style scoped>

</style>
